export default {
      Menus: 'قائمة نظام|قوائم النظام',
};
